import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="not-found-page">
      <Navbar forceSolid />
      <main className="max-w-4xl mx-auto px-6 pt-40 pb-24">
        <p className="text-sm font-semibold text-teal-700 mb-4" data-testid="not-found-status">404</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6" data-testid="not-found-title">Page not found</h1>
        <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-900 transition-colors">
          <ArrowLeft size={18} aria-hidden="true" /> Back to Home
        </Link>
      </main>
      <Footer />
    </div>
  );
}